import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { classNames } from "@swa-ui/string";

import styles from "./CaptionPointer.module.scss";

/**
 * CaptionPointer is a low level component that provides a simple caret, in one of four directions, that is current only
 * used by Caption.
 */
export const CaptionPointer = (props) => {
  const { className, direction, style } = props;
  const [previousDirection, setPreviousDirection] = useState(direction);

  useEffect(() => {
    if (direction !== "hidden") {
      setPreviousDirection(direction);
    }
  }, [direction]);

  return (
    <div {...getProps()}>
      <div className={getPositionClass()}>
        <div className={getPointerClass()} />
      </div>
    </div>
  );

  function getProps() {
    return {
      className: getClass(),
      ...(style && { style }),
    };
  }
  function getClass() {
    return classNames(
      styles.captionPointer,
      {
        [styles.down]: previousDirection === "down",
        [styles.left]: previousDirection === "left",
        [styles.right]: previousDirection === "right",
        [styles.up]: previousDirection === "up",
      },
      className
    );
  }

  function getPositionClass() {
    return classNames({
      [styles.positionDown]: previousDirection === "down",
      [styles.positionLeft]: previousDirection === "left",
      [styles.positionRight]: previousDirection === "right",
      [styles.positionUp]: previousDirection === "up",
    });
  }

  function getPointerClass() {
    return classNames(styles.pointer, {
      [styles.down]: previousDirection === "down",
      [styles.left]: previousDirection === "left",
      [styles.right]: previousDirection === "right",
      [styles.up]: previousDirection === "up",
    });
  }
};

CaptionPointer.displayName = "CaptionPointer";

CaptionPointer.propTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Defines which direction the CaptionPointer will point. */
  direction: PropTypes.oneOf(["down", "hidden", "left", "right", "up"]),

  /** Object to be applied outer DOM element's style attribute. */
  style: PropTypes.object,
};
